import React from 'react';
import styled from 'styled-components';

const Svg = styled.svg`
  height: 14px;
  width: 14px;
`;

function Add() {
    return (
    <Svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 14V8H0V6H6V0H8V6H14V8H8V14H6Z" fill="#384478"/>
    </Svg>
    );
  }

export default Add;